import { Flex, Checkbox } from '@mezzoforte/forge';
import { useContext } from 'react';
import InfoTooltip from '@/components/InfoTooltip/InfoTooltip';
import { SidebarDivider } from '@/features/EntryPage/SidebarSection';
import { useFavorites } from '@/hooks/useFavorites';
import { useShouldDisplaySmsNotificationToggle } from '@/hooks/useShouldDisplaySmsNotificationToggle';
import { BiddingContext } from '@/context/BiddingContext';

interface SmsNotificationToggleProps {
  entryId: number;
}

export function SmsNotificationToggle({ entryId }: SmsNotificationToggleProps) {
  const { hasSmsNotification, toggleSmsNotification } = useFavorites();
  const { vatPerc } = useContext(BiddingContext);
  const { shouldDisplaySmsNotificationToggle } = useShouldDisplaySmsNotificationToggle(entryId, vatPerc);

  if (!shouldDisplaySmsNotificationToggle) return null;

  return (
    <SidebarDivider>
      <Flex
        px={3}
        py={0}
        alignItems="center"
      >
        <Checkbox
          size="sm"
          isReadOnly={toggleSmsNotification.status === 'pending'}
          onChange={() => toggleSmsNotification.mutate(entryId)}
          isChecked={hasSmsNotification(entryId)}
        >
          Tekstarimuistutus
        </Checkbox>
        <InfoTooltip label="Sinulle lähetetään muistutus tekstiviestitse tunti ennen kohteen päättymistä. Palvelu on ilmainen." />
      </Flex>
    </SidebarDivider>
  );
}
